// extracted by mini-css-extract-plugin
export default {"layout":"layout-xiEN","buttons":"buttons-qsoR"};